import { Toolbar } from "react-admin"
import { ClientSaveButton } from "./ClientSaveButton"


export const ClientSaveToolbar = () => {
   return <Toolbar>
        <ClientSaveButton />
      </Toolbar>
};